import styled from 'styled-components';

export const StyledViewAuth = styled.div`
  text-align: center;
  padding: 100px;
  width: 100%;

  img {
    margin-bottom: 70px;
  }
`;
